import React, { useEffect, useState } from "react";
import { Offcanvas, Table } from "react-bootstrap";
import { MdRestore } from "react-icons/md";
import { NoDataFoundTable, PageLoader } from "../../../../Components/NoDataFoundTable/NoDataFoundTable";
import { studyEventManagementServices } from "../../../../APIServices/CTMS/EventManagement/studyEventManagementServices";
import Swal from "sweetalert2";
import { useParams } from "react-router";

const DeletedStudySubjectEventUnscheduleForm = ({
  tableRef,
  onMouseDown,
  Show,
  Hide,
  Title,
  activeTabName,
  getStudyFormListBasedonEventSchema,
  unscheduledFormLoader,
  deletedUnscheduledFormList,
  getDeletedAssignedSubjectEventUnscheduledForm
}) => {
  const StudyMode = JSON.parse(localStorage.getItem("StudyMode"));
  let { studyId } = useParams();
  const softDeleteRestoreStudySubjectEventUnscheduledForm = async (formId, formVersion, formType, type) => {
    Swal.fire({
      title: "Are you sure?",
      text: `You want to ${type} form on this Event!`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#103C5E",
      cancelButtonColor: "#d33",
      confirmButtonText: `Yes, ${type} it!`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        let userData = {
          mode: StudyMode,
          studyId,
          siteId: activeTabName?.siteId,
          subjectId: activeTabName?.subjectId,
          schemaId: activeTabName?.schemaId,
          eventId: activeTabName?.eventId,
          formId,
          formVersion,
          formType,
          type,
        };

        if (activeTabName?.timePointUniqueId) {
          userData.timePointUniqueId =
            activeTabName?.timePointUniqueId;
        }

        let data =
          await studyEventManagementServices.softDeleteRestoreStudySubjectEventUnscheduledForm(
            userData
          );
        if (data?.statusCode === 200) {
          getStudyFormListBasedonEventSchema();
          getDeletedAssignedSubjectEventUnscheduledForm();
        }
      }
    });
  };

  return (
    <>
      <Offcanvas
        show={Show}
        onHide={Hide}
        style={{ width: 575 }}
        placement="end"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body className="p-0">
          {unscheduledFormLoader ? (
            <PageLoader />
          ) : deletedUnscheduledFormList?.length === 0 ? (
            <div
              className="hstack justify-content-center"
              style={{ height: "calc(100vh - 44px)" }}
            >
              <NoDataFoundTable MSG={"Unscheduled From not deleted yet."} />
            </div>
          ) : (
            <>
              <Table ref={tableRef} className="m-0 custom-table" hover striped>
                <thead className="position-sticky top-0 z-1">
                  <tr>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 0)}
                      style={{ width: 45 }}
                      className="text-center"
                    >
                      Sr.
                    </th>
                    <th onMouseDown={(e) => onMouseDown(e, 1)}>Form Name</th>
                    <th onMouseDown={(e) => onMouseDown(e, 2)}>Form Version</th>
                    <th onMouseDown={(e) => onMouseDown(e, 3)}>Form Type</th>
                    <th
                      onMouseDown={(e) => onMouseDown(e, 4)}
                      style={{ width: 55 }}
                      className="text-center"
                    >
                      Restore
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {deletedUnscheduledFormList?.map((item, index) => (
                    <tr key={index} title="View Details">
                      <td className="text-center">{index + 1}.</td>
                      <td>{item?.formName}</td>
                      <td>
                        v{item?.formVersion}
                      </td>
                      <td className="text-capitalize">
                        {item?.formType}
                      </td>
                      <td className="text-center" title="Restore">
                        <MdRestore
                          style={{ fontSize: 16 }}
                          onClick={(e) =>
                            softDeleteRestoreStudySubjectEventUnscheduledForm(
                              item?.formId, item?.formVersion, item?.formType,
                              "restore"
                            )
                          }
                          className="text-success CP"
                        />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </>
          )}
        </Offcanvas.Body>
      </Offcanvas>
    </>
  );
};

export default DeletedStudySubjectEventUnscheduleForm;
